import * as React from "react";
const SvgSend = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgSend as ReactComponent };